import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import { compose } from 'redux';
import classnames from 'classnames';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import withSelectedDeviations from '../../_hocs/withSelectedDeviations';
import IndicatorForDeviationThumb from '../IndicatorForDeviationThumb';
import s from './SelectableDeviationWrapper.scss';
const enhance = compose(withSelectedDeviations);
export class SelectableDeviationWrapper extends React.Component {
    render() {
        const { deviation, selectionLimit, selectedDeviations, canSelectMore, className } = this.props;
        const isSelected = !!selectedDeviations.find((selectedDeviation)=>selectedDeviation.typeId === deviation.typeId && selectedDeviation.deviationId === deviation.deviationId);
        const isDisabled = this.props.isDisabled || selectionLimit > 1 && !isSelected && !canSelectMore;
        return /*#__PURE__*/ React.createElement("div", {
            className: classnames(s['root'], isSelected && s['selected'], isDisabled && s['disabled'], className),
            draggable: false,
            onClick: this.onToggleSelect
        }, isSelected && /*#__PURE__*/ React.createElement(CheckIcon, {
            className: s['check']
        }), /*#__PURE__*/ React.createElement(IndicatorForDeviationThumb, {
            deviation: deviation,
            className: s['indicator']
        }), this.props.children);
    }
    constructor(...args){
        super(...args), _define_property(this, "onToggleSelect", ()=>{
            this.props.onSelectableItemClick(this.props.deviation);
        });
    }
}
export default enhance(SelectableDeviationWrapper);

//# sourceMappingURL=SelectableDeviationWrapper.js.map